import React from "react";
import styled from "styled-components";

import MUILink from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { useLocation } from "react-router";

import { INFO_EMAIL_ADDRESS, PHONE_NUMBER } from "../../constants/general";
import { getOAuthError, parseOAuthError } from "../../helpers/oauthError";

export const OAUTH_ERROR_URL = "/oauth-error";

const Container = styled.section`
  padding: 24px;
`;

export const Link = styled(MUILink)`
  cursor: pointer;
  display: inline-block;
  text-decoration: underline !important;
  color: #007bff !important;
`;

const DEFAULT_ERROR_MESSAGE = "We were unable to sign you in.";

export const OAuthErrorContainer: React.FC = () => {
  const location = useLocation();
  const oauthError = parseOAuthError(location.search) ?? getOAuthError();
  const error = oauthError?.error;
  const errorDescription = oauthError?.errorDescription;

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        Sign In Error
      </Typography>
      <Typography paragraph>{errorDescription || DEFAULT_ERROR_MESSAGE}</Typography>
      {error && (
        <Typography paragraph color="textSecondary">
          Error: {error}
        </Typography>
      )}
      <Typography paragraph>
        If this problem persists, please email{" "}
        <Link href={`mailto:${INFO_EMAIL_ADDRESS}`}>{INFO_EMAIL_ADDRESS}</Link> or call {PHONE_NUMBER}.
      </Typography>
    </Container>
  );
};
